import { useSelector } from "react-redux"

export default function PageFooter(props) {
	const user = useSelector(state => state.sysuserInfo || {})

	return <div style={{
		background: "transparent",
		fontSize: "14px",
		display: "flex",
		alignItems: "center",
		justifyContent: "center",
		marginBottom: "30px",
		...(props.style || {})
	}}>
		<div style={{ marginRight: "20px" }}>技术支持: 山东荣大信息科技有限公司</div>
		<div>联合开发: {user.buyerOrgName}</div>
	</div>
}
